import * as v from 'valibot';
import { CfBotScoreSchema, VerifiedBotSchema } from './headersSchema';

export function isLikelyABotBasedOnScore(score: number) {
  // Taken from https://developers.cloudflare.com/bots/concepts/bot-score/#bot-groupings
  return score > 0 && score < 30;
}

export function getCFBotHeaders(request: { headers: Headers }) {
  const headers = request.headers;
  // These headers are set by the Cloudflare worker in cf-proxies
  // https://github.com/NerdWallet/cf-proxies/blob/89e6a7a63fa6e5e3980ab2fd3345d09a005c33c6/worker-configuration.d.ts#L18
  const cfBotScore = headers.get('x-cf-bot-score') ?? '';
  const isVerifiedBot = headers.get('x-cf-verified-bot') ?? '';

  const validatedCfBotScore = v.safeParse(CfBotScoreSchema, cfBotScore);
  const validatedIsVerifiedBot = v.safeParse(VerifiedBotSchema, isVerifiedBot);
  const isAKnownConfirmedBot = validatedIsVerifiedBot.success
    ? validatedIsVerifiedBot.output
    : false;
  const score = validatedCfBotScore.success ? validatedCfBotScore.output : 0;
  const isLikelyBot = isLikelyABotBasedOnScore(score);

  return {
    isBot: isLikelyBot,
    isVerifiedBot: isAKnownConfirmedBot,
    cfBotScore: score,
    cfVerifiedBot: isVerifiedBot,
  };
}
